var _circle, _circle2, _line, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightDesktopRouteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 13,
    viewBox: "0 0 108 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 8,
    r: 3.5,
    stroke: "#FFC629"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 8,
    r: 3.5,
    stroke: "#FFC629"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7.5,
    x2: 98,
    y2: 7.5,
    stroke: "#D1D1D1",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5953 8.125H55.5237L52.7867 12.7954C52.7502 12.8576 52.6975 12.9092 52.634 12.9452C52.5704 12.9811 52.4982 13 52.4247 13H50.719C50.6545 13 50.591 12.9854 50.5333 12.9573C50.4756 12.9293 50.4253 12.8886 50.3865 12.8384C50.3477 12.7882 50.3213 12.7299 50.3095 12.6681C50.2977 12.6063 50.3008 12.5427 50.3185 12.4823L51.5953 8.125ZM50.3193 0.517968C50.3015 0.457572 50.2984 0.393991 50.3102 0.332225C50.3219 0.270457 50.3482 0.212186 50.3869 0.16199C50.4257 0.111794 50.4758 0.0710411 50.5334 0.0429335C50.5911 0.0148258 50.6546 0.0001297 50.719 0H52.4247C52.4982 3.8147e-06 52.5703 0.0189342 52.6338 0.0548725C52.6974 0.0908108 52.75 0.142482 52.7864 0.204648L55.5237 4.875H51.5953L50.3193 0.517968Z",
    fill: "#FFD45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4999 4.875H48.9166L47.7916 3.4125C47.7528 3.36205 47.7024 3.32109 47.6446 3.29289C47.5867 3.26468 47.5229 3.25 47.4583 3.25H46.4166C46.3533 3.25005 46.2908 3.26415 46.234 3.29124C46.1771 3.31834 46.1273 3.3577 46.0884 3.40636C46.0495 3.45501 46.0224 3.51167 46.0093 3.57204C45.9962 3.63241 45.9973 3.6949 46.0127 3.75477L46.8333 6.5L46.0127 9.24523C45.9973 9.3051 45.9962 9.36759 46.0093 9.42796C46.0224 9.48833 46.0495 9.54499 46.0884 9.59364C46.1273 9.6423 46.1771 9.68166 46.234 9.70875C46.2908 9.73585 46.3533 9.74995 46.4166 9.75H47.4583C47.5229 9.75 47.5867 9.73532 47.6446 9.70711C47.7024 9.67891 47.7528 9.63795 47.7916 9.5875L48.9166 8.125H58.4999C59.4205 8.125 60.9999 7.39756 60.9999 6.5C60.9999 5.60244 59.4205 4.875 58.4999 4.875Z",
    fill: "#FFC629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 46 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDesktopRouteIcon);
export default __webpack_public_path__ + "static/media/flight-desktop-route-icon.9db8c0927fbac9aaa76bf063ae25f660.svg";
export { ForwardRef as ReactComponent };